import { createAsyncThunk } from "@reduxjs/toolkit";
import { enqueueSnackbar } from "notistack";
import { changePassword, login, logout } from "../../services/auth.service";
import { RootState } from "../store";

const getAuthToken = () => {
  return localStorage.getItem("token") || "{}";
};
export const doLogin = createAsyncThunk("auth/login", async (body: any) => {
  const response: any = await login(body);
  return response;
});

export const doChangePassword = createAsyncThunk(
  "auth/changePassword",
  async (body: any, { getState, rejectWithValue }) => {
    const state = getState() as RootState;
    const accessToken = getAuthToken();
    if (!accessToken) {
      throw new Error("Authentication token not found");
    }
    try {
      const response: any = await changePassword(accessToken, body);
      return response;
    } catch (error: any) {
      enqueueSnackbar(
        error.response?.data?.message || "Failed to change password",
        { variant: "error" }
      );
      return rejectWithValue(
        error.response?.data?.message || "Failed to change password"
      );
    }
  }
);

export const doLogout = createAsyncThunk(
  "auth/logout",
  async (_, { getState, rejectWithValue }) => {
    const state = getState() as RootState;
    const accessToken = getAuthToken();
    if (!accessToken) {
      throw new Error("Authentication token not found");
    }

    try {
      const response: any = await logout(accessToken);
      enqueueSnackbar("Logged out successfully", { variant: "success" });
      return response.data;
    } catch (error: any) {
      enqueueSnackbar(error.response?.data?.message || "Logout failed", {
        variant: "error",
      });
      return rejectWithValue(error.response?.data?.message || "Logout failed");
    }
  }
);
